import type { SearchItem } from '@bulknutrients/bulk-shared-lib/interfaces/Search';

import { TextLink } from '@components/Typography/TextLink/TextLink';
import type { ReactElement } from 'react';

export const SearchResultsLinkList = ({
  items,
  maxItems = 4,
  noResultsMessage = 'No results found',
}: {
  items: Array<SearchItem>;
  maxItems?: number;
  noResultsMessage: string;
}): ReactElement => (
  <>
    {!items.length ? (
      <p>{noResultsMessage}</p>
    ) : (
      <div className="flex flex-col">
        {items.slice(0, maxItems).map((item) => {
          return (
            <TextLink
              href={item.slug ?? '#'}
              key={item.slug}
              data-umami-event-location="Autocomplete Search Results Link List"
            >
              {item.title}
            </TextLink>
          );
        })}
      </div>
    )}
  </>
);
